export const getters = {
  getBranches($state) {
    return $state.records;
  },
  getBranch: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getMyBranches($state) {
    return $state.records.filter(branch => branch.is_member);
  },
};
